import * as types from './types'
import { set as setData, remove as removeData } from '@/lib/local-storage'


export default {


  [types.SET_BREADCRUMB]: (state, value) => {
    state.breadcrumb = value
  },

  [types.SET_ACCOUNT]: (state, value) => {
    setData(types.SET_ACCOUNT, value)
  },

  [types.SET_FIREBASE]: (state, value) => {
    setData(types.SET_FIREBASE, value)
  },

  [types.NOTIF_FIREBASE]: (state, value) => {
    state.firebaseNotif = value
    setData(types.NOTIF_FIREBASE, value)
  },

  [types.LOGOUT]: (state) => {
    state.$account = null
    removeData(types.ACCOUNT_COOKIE)
    // Reset session-scoped state so a subsequent login (without a full page
    // reload) re-runs the app's bootstrap logic instead of skipping it
    // because stale in-memory state makes it look like a restaurant/session
    // is already selected.
    state.selectedRestaurantId = null
    state.restaurants = []
    state.ClientTypeID = null
    state.menuEditorLink = null
    state.$businessProfile = {}
    state.requiredPin = false
    state.initialAutoLogoutTimer = false
    state.autoLogoutTimerValue = 90
    state.firebaseNotif = false
  },

  [types.SET_UPLOAD_PROGRESS]: (state, value) => {
    state.$uploadProgress = value
  },
  [types.CHANGERESTAURANT]: (state, value) => {
    state.selectedRestaurantId = value
  },
  [types.RESTAURANTS]: (state, value) => {
    state.restaurants = value
  },
  [types.SET_REQUIRED_PIN]: (state, value) => {
    state.requiredPin = value
  },
  [types.SET_INITIAL_AUTO_LOGOUT_TIMER]: (state, value) => {
    state.initialAutoLogoutTimer = value
  },
  [types.SET_AUTO_LOGOUT_TIMER_VALUE]: (state, value) => {
    state.autoLogoutTimerValue = value
  },
  [types.MENU_EDITOR]: (state, value) => {
    state.menuEditorLink = value
  },
  [types.CLIENT_TYPE_ID]: (state, value) => {
    state.ClientTypeID = value
  },

  [types.SET_DOWNLOAD_PROGRESS]: (state, value) => {
    state.$downloadProgress = value
  },

  [types.SET_OFFLINE]: (state, value) => {
    state.$offline = value
  },

  [types.BUSINESS_PROFILE]:(state, value)=>{
    state.$businessProfile = value
  }
}
